"use strict";
/*
 * Created on 09.05.2019
 */

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PromoSettingsValidatorSets_1 = require("../PromoSettingsValidatorSets");
/**
 * Cherry pick settings model
 * @author Tomáš Leity
 *
 * @param cherryPickSettingsStatus
 * @param thresholdTransactionSales
 * @param thresholdTransactionVolume
 * @param thresholdProduct
 */


var CherryPickSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CherryPickSettings, _DomainObject_1$Domai);

  function CherryPickSettings(cherryPickSettingsStatus, thresholdTransactionSales, thresholdTransactionVolume, thresholdProduct) {
    var _this;

    _classCallCheck(this, CherryPickSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CherryPickSettings).call(this));
    _this.cherryPickSettingsStatus = cherryPickSettingsStatus;
    _this.thresholdTransactionSales = thresholdTransactionSales;
    _this.thresholdTransactionVolume = thresholdTransactionVolume;
    _this.thresholdProduct = thresholdProduct;
    return _this;
  }

  return CherryPickSettings;
}(DomainObject_1.DomainObject);

exports.CherryPickSettings = CherryPickSettings;

CherryPickSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CherryPickSettings.name);
  return {
    cherryPickSettingsStatus: builder.bool('cherryPickSettingsStatus'),
    thresholdTransactionSales: builder.num.apply(builder, ['thresholdTransactionSales'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    thresholdTransactionVolume: builder.num.apply(builder, ['thresholdTransactionVolume'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    thresholdProduct: builder.num.apply(builder, ['thresholdProduct'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators)))
  };
}();